(function () {
  var resizeTimer;

  function isFaqMobile() {
    return window.matchMedia('(max-width: 991px)').matches;
  }

  function getOrderedFaqCards(masonry) {
    var stock = masonry.querySelector('.faq-grid__stock');
    var left = masonry.querySelector('[data-faq-column="left"]');
    var right = masonry.querySelector('[data-faq-column="right"]');
    var cards = [];

    if (stock) {
      cards = cards.concat(Array.from(stock.querySelectorAll('[data-faq-card]')));
    }
    if (left) {
      cards = cards.concat(Array.from(left.querySelectorAll('[data-faq-card]')));
    }
    if (right) {
      cards = cards.concat(Array.from(right.querySelectorAll('[data-faq-card]')));
    }

    cards.sort(function (a, b) {
      return (
        (parseInt(a.getAttribute('data-faq-order'), 10) || 0) -
        (parseInt(b.getAttribute('data-faq-order'), 10) || 0)
      );
    });

    return cards;
  }

  function balanceFaqMasonry() {
    var masonry = document.querySelector('[data-faq-masonry]');
    if (!masonry) return;

    var left = masonry.querySelector('[data-faq-column="left"]');
    var right = masonry.querySelector('[data-faq-column="right"]');
    if (!left || !right) return;

    var cards = getOrderedFaqCards(masonry);
    if (!cards.length) return;

    masonry.classList.remove('is-ready');
    left.innerHTML = '';
    right.innerHTML = '';

    if (isFaqMobile()) {
      cards.forEach(function (card) {
        left.appendChild(card);
      });
      right.hidden = true;
    } else {
      right.hidden = false;

      cards.forEach(function (card) {
        var leftHeight = left.getBoundingClientRect().height;
        var rightHeight = right.getBoundingClientRect().height;

        if (leftHeight <= rightHeight) {
          left.appendChild(card);
        } else {
          right.appendChild(card);
        }
      });
    }

    masonry.classList.add('is-ready');
  }

  function closeAllFaqAnswers() {
    document.querySelectorAll('.main-faqs .faq-question').forEach(function (question) {
      question.classList.remove('open');
      var content = question.querySelector('.accordion__content');
      if (content) content.style.display = 'none';
    });
  }

  function initFaqSeeAll() {
    document.querySelectorAll('[data-faq-see-all]').forEach(function (button) {
      if (button.dataset.faqInitialized === 'true') return;
      button.dataset.faqInitialized = 'true';

      button.addEventListener('click', function () {
        var card = button.closest('.faq-card');
        if (!card) return;

        card.classList.add('is-expanded');
        card.querySelectorAll('.faq-question-item--hidden').forEach(function (item) {
          item.classList.remove('faq-question-item--hidden');
        });
        button.hidden = true;
      });
    });
  }

  function initFaqCardAnimations() {
    var cards = document.querySelectorAll('[data-faq-masonry] [data-faq-card]:not(.is-visible)');

    if (!cards.length) return;

    if (!('IntersectionObserver' in window)) {
      cards.forEach(function (card) {
        card.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -30px 0px'
      }
    );

    cards.forEach(function (card) {
      observer.observe(card);
    });
  }

  function initFaqAnswerLinks() {
    document.querySelectorAll('.main-faqs .faq-question__content a[href]').forEach(function (link) {
      if (link.target !== '_blank') {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      }
    });
  }

  function initFaqSection() {
    balanceFaqMasonry();
    closeAllFaqAnswers();
    initFaqSeeAll();
    initFaqAnswerLinks();
    initFaqCardAnimations();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaqSection);
  } else {
    initFaqSection();
  }

  document.addEventListener('shopify:section:load', initFaqSection);

  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      balanceFaqMasonry();
      initFaqSeeAll();
      initFaqAnswerLinks();
      initFaqCardAnimations();
    }, 180);
  });
})();
